import React from 'react';
import { connect } from 'react-redux'
import { Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import i18n from "utils/I18n";
import { showBreadCrumb } from 'utils/UIConfigUtils'
import { inMiniProgram } from 'utils/WeChatUtil';

function OneBreadCrumb({ item }) {
    const { path, name } = item
    if (!path) {
        return <span className="nav_row_span">{i18n.t(name)}</span>
    }
    return (
        <>
            <Link to={path}>{i18n.t(name)}</Link>
            <div>{'>'}</div>
        </>
    )
}

function BreadCrumbs({ breadList }) {
    const showBread = showBreadCrumb()
    const isInMiniProgram = inMiniProgram()
    return (
        <Row className={`nav_row button-large ${showBread && !isInMiniProgram ? '' : 'hidden'}`} style={{ paddingTop: '12px' }}>
            {
                breadList.map(item => <OneBreadCrumb item={item} />)
            }
        </Row>
    )
}

const mapStateToProps = (state) => ({
    language: state.users.language
});

export default connect(mapStateToProps)(BreadCrumbs);